import { MAP_ELEMENT_TYPES } from '../../../../constants/graph';
import MapElementModal from '../../../graph/MapElementModal';
import screens from '../common/screens';
import {
    type MapElementConfigProps,
    MapElementProvider,
} from '../contextProviders/MapElementProvider';
import { OperatorProvider } from './OperatorProvider';
import OperatorRouter from './OperatorRouter';

const Operator = (props: MapElementConfigProps) => {
    return (
        <MapElementProvider
            {...props}
            defaultScreen={screens.operator}
            elementType={MAP_ELEMENT_TYPES.operator}
            isLoading={false}
        >
            <MapElementModal>
                <OperatorProvider>
                    <OperatorRouter />
                </OperatorProvider>
            </MapElementModal>
        </MapElementProvider>
    );
};

export default Operator;
